// Locale context and hooks for O-Ton

import { createContext, useContext, type ReactNode } from "react";

import type { Locale } from "@/types/content";

import { DEFAULT_LOCALE } from "./localized";

interface LocaleContextValue {
  locale: Locale;
  setLocale?: (locale: Locale) => void;
}

const LocaleContext = createContext<LocaleContextValue>({
  locale: DEFAULT_LOCALE,
});

export function LocaleProvider({
  locale = DEFAULT_LOCALE,
  children,
}: {
  locale?: Locale;
  children: ReactNode;
}) {
  return <LocaleContext.Provider value={{ locale }}>{children}</LocaleContext.Provider>;
}

export function useLocale(): LocaleContextValue {
  return useContext(LocaleContext);
}
